var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGigpig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1510_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07018 18.6057C3.16548 18.6057 0 21.1558 0 24.3028C0 27.4499 3.16548 30 7.07018 30C10.9749 30 14.1404 27.4491 14.1404 24.3028C14.1404 21.1566 10.9749 18.6057 7.07018 18.6057ZM4.71447 25.9756C3.54582 25.9756 3.55503 22.7551 4.71447 22.7551C5.87392 22.7551 5.87392 25.9756 4.71447 25.9756ZM9.39598 25.9685C8.22733 25.9685 8.23653 22.7481 9.39598 22.7481C10.5554 22.7481 10.5554 25.9685 9.39598 25.9685Z",
    fill: "#EF7192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1404 1.45709H12.9403V24.302H14.1404V1.45709Z",
    fill: "#EF7192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9691 7.38398C19.0404 9.34658 22.3239 12.5389 23.955 12.935C24.4856 13.064 24.5286 12.8796 24.7126 12.6952C25.1926 12.2124 25.563 11.4506 25.9181 10.7998C26.339 10.0286 26.6197 9.20048 27.0407 8.43013C27.3796 7.31835 27.8482 6.49409 28.0882 5.85734C28.4172 4.98463 28.7201 4.08849 28.9808 3.14938C29.0368 2.94703 28.9693 2.64701 28.819 2.49622C27.7209 1.3907 25.2962 0.853169 25.1811 0.796916C23.0194 0.232824 20.9329 0.0882856 18.8302 -2.11209e-07C17.6823 -0.00546925 16.4124 0.094536 15.5689 0.258607C15.1939 0.311735 14.8243 0.362519 13.9915 0.682848C13.5468 0.85395 13.2362 1.12662 13.0046 1.31726C12.9464 1.36335 12.9402 1.41179 12.9464 1.48445C13.5537 4.11271 15.4846 5.56201 16.9691 7.38398Z",
    fill: "#EF7192"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1510_1236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigpig);
export default __webpack_public_path__ + "static/media/gigpig.de0ee9d31e79bcdf926128b717e305a0.svg";
export { ForwardRef as ReactComponent };